// InnHealth brand marks — a clinical ECG/heartbeat signature.
// Pure SVG, no client hooks: safe to render in server components (AppShell branding,
// layouts) and client pages (login) alike.

/** Rounded teal tile + white heartbeat — the primary mark for light surfaces. */
export function LogoMark({
  size = 32,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      role="img"
      aria-label="InnHealth"
      className={className}
    >
      <defs>
        <linearGradient
          id="ih-logo-grad"
          x1="0"
          y1="0"
          x2="32"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#16a6bd" />
          <stop offset="1" stopColor="#0a6478" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#ih-logo-grad)" />
      <path
        d="M5 16.5H11L13.5 9L18 23L20.5 16.5H27"
        stroke="white"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Mark + wordmark lockup for headers and the login panel. */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className ?? ""}`}>
      <LogoMark size={30} />
      <span className="font-display text-lg font-semibold tracking-tight">
        Inn<span className="text-primary">Health</span>
      </span>
    </span>
  );
}
